import { NgModule } from '@angular/core';
import { MarkdownEditorModule } from '../markdown-editor/markdown-editor.module';
import { BugReportDialogComponent } from './bug-report.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        BugReportDialogComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        ReactiveFormsModule,


        MatSelectModule,
        MatOptionModule,
        // MatDialogModule,
        MarkdownEditorModule,
        
    ],
    providers: [
    ],
    exports: [
        BugReportDialogComponent
    ],
    entryComponents: [
        BugReportDialogComponent
    ]
})
export class BugReportModule {
}